import { Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, forkJoin } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MultiLangService {
  public validLanguages = ['en', 'es', 'fr', 'pt'];
  public defaultLanguage = 'en';
  public languageChanged = signal<string>('');
  private languageSubject = new BehaviorSubject<string>(
    this.getStoredLanguage()
  );
  language$ = this.languageSubject.asObservable();

  constructor(private translateService: TranslateService) {
    this.loadAllTranslations();
    this.updateLanguage(this.getStoredLanguage());
  }

  public getStoredLanguage(): string {
    return localStorage.getItem('language') || navigator.language.slice(0, 2);
  }

  updateLanguage(language: string) {
    const langToUse = this.validLanguages.includes(language)
      ? language
      : this.defaultLanguage;
    localStorage.setItem('language', langToUse);
    this.translateService.use(langToUse);
    this.languageChanged.set(langToUse);
    this.languageSubject.next(langToUse);
  }

  getLanguages() {
    return this.validLanguages;
  }

  getLangName(language: string): string {
    const languages: Record<string, string> = {
      en: 'ENG',
      es: 'ESP',
      pt: 'POR',
      fr: 'FRA',
    };
    return languages[language] || 'ENG';
  }

  loadAllTranslations() {
    forkJoin(
      this.validLanguages.map((lang) => this.translateService.reloadLang(lang))
    );
  }
}
